import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';
import StopPropagationWrapper from 'components/common/StopPropagationWrapper';

import { useModal } from 'vibo-ui/Modal';
import { getFullName } from 'services/users/helpers';

import { IconmoonFont } from 'vibo-ui/Icon';
import { Modals, ViboUserRole } from 'types/enums';
import { DjsPreviewModalProps } from 'components/modals/DjsPreviewModal';
import { UpdateUserModalProps } from 'components/modals/UpdateUserModal';
import { UserRowProps } from './interfaces';

import useStyles from './style';

const UserRole: FC<UserRowProps> = ({ user }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const { openModal } = useModal();

  const openUpdateUserModal = (option: UserPreview) =>
    openModal<UpdateUserModalProps>({
      key: Modals.updateUser,
      props: {
        user: (option as unknown) as ViboUser,
      },
    });

  const openDjsPreviewModal = () =>
    openModal<DjsPreviewModalProps>({
      key: Modals.djsPreview,
      props: {
        title: fullName,
        djs: (user.children as unknown) as UserPreview[],
        onClick: openUpdateUserModal,
      },
    });

  const isCompany = user.role === ViboUserRole.company;

  const role = t(user.role);

  const childrenCount = user.children.length;
  const fullName = getFullName(user);
  const masterDjName = user.parent && getFullName(user.parent[0]);

  return (
    <StopPropagationWrapper className={classes.roleInfo}>
      {role}
      {isCompany && childrenCount ? (
        <Button
          onClick={openDjsPreviewModal}
          sufixIcon={IconmoonFont['caretRight-16']}
          shape="round"
        >
          <span className="label">{`${childrenCount} ${t('dj', { count: childrenCount })}`}</span>
        </Button>
      ) : (
        <span className="label">{masterDjName}</span>
      )}
    </StopPropagationWrapper>
  );
};

export default UserRole;
